import React from 'react';

import { Trans } from 'lingui-react';
import { Button, Modal, ModalBody } from 'reactstrap';

import finishPopup from '../../../../assets/images/finish_popup.svg';
import './modalFinish.css';

export const ModalFinish = props => {
  return (
    <div>
      <Modal backdrop='static' isOpen={props.modal} toggle={props.toggle} className={'mx-auto modal-finish-question '+ props.className } >
        <ModalBody>
          <div className="row">
            <div className="col-12 col-sm-5">
              <img className="img-fluid" alt="" src={finishPopup} />
            </div>
            <div className="col-12 col-sm-7">
              <p className="modal-text"><Trans id="Please answer all questions first
               so that afterwards the evaluation can be created."/></p>
              <Button className="back-to-question" color="primary" onClick={props.toggle}><Trans id="Back to the questionnaire"/></Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/screens/Question/components/ModalFinish/ModalFinish.js